export const initialSettingsState: SettingsState = {
    panel: {
        id: null,
        supervisor_connection_address: '',
    },
};

export type SettingsState = SettingsModel;
export type PanelSettingsModel = {
    id: string;
    supervisor_connection_address: string;
};

export type SettingsModel = {
    panel: PanelSettingsModel;
};
